import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { apiProvider as apiProviderLeads } from '@/modules/crm/CustomerLeads/api';
import { END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listActions, listMutations } from './types';

export const dropdownList = {
	ProvozovnaId: [],
	OzakazkaPzn: [],
	ZakazkaDruh: [],
	SmVariaList: [],
	Statusobjdms: [],
	OzDisponNdZkt: [],
};

export const filter = {
	PripravaPrp: null as boolean | null,
	VyrizenoPrp: null as boolean | null,
	OzakazkaPzn: null as number | null,
	ZakazplanDatOd: null as string | null,
	ZakazplanDatDo: null as string | null,
	ZakazkaId: null as number | null,
	ZakazkaNr: null as number | null,
	ZakazkaText: null as string | null,
	ProvozovnaId: null as number | null,
	Statusobjdms: null as number | null,
	ZakazkaDruh: null as string | null,
	OzakazkaNr: null as number | null,
	Spz: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupPracOsobniCis: null as string | null,
	OzDisponNdZkt: null as string | null,
	PnvId: null as number | null,
	PovId: null as number | null,
	SmVariaList: [],
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {
		[listActions.CHECK_FOLLOWUP_DATE]: async ({ commit }) => {
			commit(START_LOADING);
			const res = await apiProviderLeads.checkFollowupDate();
			commit(listMutations.SET_FOLLOWUP_DATE_FLAG, res);
			commit(END_LOADING);
		},
	},
	extraGetters: {},
	extraMutations: {
		[listMutations.SET_FOLLOWUP_DATE_FLAG]: (state, { data }) => {
			if (data) {
				state.props.showInfoSideBar = true;
			}
		},
		[listMutations.OZAKAZKA_LIST_NR_SELECT_MAPPER](state, { data }) {
			state.filter.ZakazkaText = data.text;
			state.filter.ZakazkaNr = data.nr;
			state.filter.ZakazkaId = data.value;
		},
		[listMutations.OZAKAZKA_LIST_ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		[listMutations.OZAKAZKA_LIST_VSTUP_PRAC_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
		showInfoSideBar: null as boolean | null,
	},
});
